import React from 'react';
import { Outlet, useNavigate, useLocation, useOutletContext } from 'react-router-dom';
import { Container, Row, Col, Nav } from 'react-bootstrap';

export function SettingsLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const context = useOutletContext();
  const userRole = context?.user?.role || context?.role;

  const getActiveKey = () => {
    const path = location.pathname;
    if (path.includes('/settings/users')) return 'users';
    if (path.includes('/settings/general')) return 'general';
    if (path.includes('/settings/export')) return 'export';
    return 'account';
  };

  return (
    <Container fluid className="py-4">
      <Row className="mb-3">
        <Col>
          <h2>Settings</h2>
        </Col>
      </Row>
      <Row>
        <Col md={3} className="mb-3">
          <Nav variant="pills" className="flex-column flex-md-column flex-row flex-wrap">
            <Nav.Item>
              <Nav.Link
                active={getActiveKey() === 'account'}
                onClick={() => navigate('/dashboard/settings/account')}
              >
                Account
              </Nav.Link>
            </Nav.Item>
            {(userRole === 'admin' || userRole === 'auditor') && (
              <Nav.Item>
                <Nav.Link
                  active={getActiveKey() === 'export'}
                  onClick={() => navigate('/dashboard/settings/export')}
                >
                  Export
                </Nav.Link>
              </Nav.Item>
            )}
            {userRole === 'admin' && (
              <>
                <Nav.Item>
                  <Nav.Link
                    active={getActiveKey() === 'users'}
                    onClick={() => navigate('/dashboard/settings/users')}
                  >
                    Users
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link
                    active={getActiveKey() === 'general'}
                    onClick={() => navigate('/dashboard/settings/general')}
                  >
                    General
                  </Nav.Link>
                </Nav.Item>
              </>
            )}
          </Nav>
        </Col>
        <Col md={9}>
          <Outlet context={context} />
        </Col>
      </Row>
    </Container>
  );
}

export default SettingsLayout;
